import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IAppState {
  loading: boolean;
  ready: boolean;
  banner: boolean;
}

export const initialState: IAppState = {
  loading: false,
  ready: false,
  banner: false,
};

export const statePropName = 'app';

export const appSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    appStart(state) {
      state.loading = true;
    },
    appStarted(state) {
      state.loading = false;
      state.ready = true;
    },
    appBanner(state, action: PayloadAction<boolean>) {
      state.banner = action.payload;
    },
    redirectSubscribe(state, action: PayloadAction<string | undefined>) {
      // handle redirect subscribe logic
    },
    appLogout(state) {
      // handle app logout logic
    },
    joinChallenge(state) {
      // handle join challenge logic
    },
    startChallenge(state) {
      // handle start challenge logic
    },
    redirectExercise(state, action: PayloadAction<string>) {
      // handle redirect exercise logic
    },
  },
});

export const AppActions = appSlice.actions;
export default appSlice.reducer;
